<template>
  <Row type="flex" justify="center">
    <Col :xxl="20" :xl="20" :xs="23">
      <Row>
        <Col span="24">
          <div class="header" :style="{ backgroundImage: 'url(./static/image/header.jpg)' }">
            <span class="title">{{ config.headerTitle }}</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <keep-alive :include="['search', 'reservation', 'online', 'modifyRegister', 'modifySearch']">
            <router-view />
          </keep-alive>
        </Col>
      </Row>
    </Col>
  </Row>
</template>

<script>
import legalize from '@image/blue.png'
export default {
  name: 'layout',
  data () {
    return {
      legalize
    }
  },
  computed: {
    config () {
      return window.config
    }
  }
}
</script>

<style lang="scss" scoped>
$xs: 576px;
.header {
  width: 100%;
  height: 235px;
  background-size: cover;
  background-position: center;
  margin-bottom: 16px;
  // @media screen and (max-width: $xs) {
  //   height: 140px;
  // }
  .title {
    font-size: 30px;
    color: #fff;
    display: inline-block;
    margin: 180px 0 0 30px;
    @media screen and (max-width: $xs) {
      margin-top: 190px;
      margin-left: 16px;
      font-size: 20px;
    }
  }
}
</style>

